import React, { useState, useMemo } from 'react'
import { AppDataContext } from '../context/Contexts'
import '../index.css'
import styles from './styles.module.scss'
import Step1New from './Step1New'
import MainStepNewScsBiz2 from './MainStepNewScsBiz2'

export default function App() {
    const [appData, setAppData] = useState({
        step: 1,
        seat: '',
        color: 'Black',
        check: undefined,
        product: undefined,
        trim: '',
        has_trims: false,
        has_cabs: false,
        year: '',
        make: '',
        model: '',
        bundle_code: undefined,
    })

    const ctxValue = useMemo(
        () => ({ currentAppData: appData, setCurrentAppData: setAppData }),
        [appData]
    )

    return (
        <AppDataContext.Provider value={ctxValue}>
            <div data-testid="app-root" className={`scs-videos-app ${styles.scs_new_design_2026} ${window.scs_father_day_2026 ? styles.scs_father_day_2026 : ''}`}>
                <Step1New id="videos" stepNumber={1} />
                <MainStepNewScsBiz2 id="videos" />
            </div>
        </AppDataContext.Provider>
    )
}
